import { HideBannerWhenOpenGame } from "@components/utils/IframeDialog/IframeDialog";
import { APP_INSTALLER_HEIGHT } from "@constants";
import preferenceSlice from "@stores/preference/slices.ts";
import { getBrandResource } from "@utils/misc";
import { BeforeInstallPromptEvent, Button, PWAInstaller, cn, useCustomEventsListener } from "kz-ui-sdk";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";

interface AppInstallerProps {}

const AppInstaller = ({}: AppInstallerProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [hideBanner, setHideBanner] = useState(false);
  const handleOnAppInstallable = (isInstallable: boolean) => {
    dispatch(preferenceSlice.actions.setDisplayAppInstaller(isInstallable));
  };

  const handleOnBeforeInstallPrompt = (e: Event) => {
    dispatch(preferenceSlice.actions.setIsAppInstallable(true));
    dispatch(preferenceSlice.actions.setAppInstallerPrompt(e as BeforeInstallPromptEvent));
  };

  const handleOnInstalled = () => {
    dispatch(preferenceSlice.actions.setIsAppInstallable(false));
  };

  useCustomEventsListener({
    [HideBannerWhenOpenGame]: (event: { detail: { hide: boolean | ((prevState: boolean) => boolean) } }) =>
      setHideBanner(event.detail.hide),
  });

  return (
    <PWAInstaller
      onBeforeInstallPrompt={handleOnBeforeInstallPrompt}
      onInstalled={handleOnInstalled}
      onInstallable={handleOnAppInstallable}
      instructionOptions={{
        openExtBrowser: {
          videoSrc: "/videos/help-open-ext-browser.mp4",
          title: t("download app"),
        },
        openShareAddHomeScreen: {
          videoSrc: "/videos/help-share-add-homescreen.mp4",
          title: t("download app"),
        },
      }}
    >
      {(onInstall, onDismiss) => (
        <div
          className={cn(
            "fixed left-1/2 top-0 z-[9998] flex w-full max-w-md flex-shrink-0 -translate-x-1/2 items-center bg-darkBrand-950 px-1",
            {
              "opacity-0": hideBanner === true,
            },
          )}
          style={{
            height: APP_INSTALLER_HEIGHT,
          }}
        >
          <button
            onClick={onDismiss}
            className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center"
          >
            <MdClose className="h-6 w-6 text-content-soft" />
          </button>
          <img
            src={getBrandResource("app-installer-icon.png")}
            className="ml-2 h-9 w-auto self-end object-cover"
            alt="install-app"
          />
          <div className="flex-grow-1 flex flex-col pl-2">
            <div className="text-sm font-semibold leading-5 text-content-base">{t("download app")}</div>
            <div className="text-[10px] leading-3 text-content-soft">{t("get free credit everyday")}</div>
          </div>
          <Button
            variant="green"
            size="sm"
            className="ml-auto mr-3 flex-shrink-0 animate-zoom-pulse rounded-lg"
            classes={{
              "root&": "!h-[26px] !w-fit px-3",
            }}
            onClick={onInstall}
          >
            {t("add")}
          </Button>
        </div>
      )}
    </PWAInstaller>
  );
};

export default AppInstaller;
